<div class="tw:flex tw:flex-col tw:gap-2.5 tw:empty:hidden">
  <ng-content select="fr8bot-ui-page-header, fr8bot-ui-page-filters-wrapper"></ng-content>
</div>

<div class="tw:flex tw:min-h-0 tw:flex-auto tw:flex-col">
  <ng-content></ng-content>
</div>
